import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteMaintenancePlanApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.HOME_MAINTENANCE.DELETE_MAINTENANCE_PLAN,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteMaintenancePlanApi;